// src/routes/index.js
import { Routes, Route } from "react-router-dom";

// Pages
import HomePage from "../pages/Home";
import AboutPage from "../pages/About";
import PrivacyPage from "../pages/PrivacyPolicy";
import TermsPage from "../pages/TermsAndCondition";
import ServicesPage from "../pages/services";
import ServiceCategoryPage from "../pages/services/Category";
import ServiceItemPage from "../pages/services/Service";
import ContactPage from "../pages/Contact";
import NotFound from "../pages/errors/NotFound";

const AppRoutes = () => {
	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/about-us" element={<AboutPage />} />
			<Route path="/privacy-policy" element={<PrivacyPage />} />
			<Route path="/terms-condition" element={<TermsPage />} />
			<Route path="/services" element={<ServicesPage />} />
			<Route path="/services/:category" element={<ServiceCategoryPage />} />
			<Route path="/services/:category/:item" element={<ServiceItemPage />} />
			<Route path="/contact-us" element={<ContactPage />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};

export default AppRoutes;
